module.exports = "img/file.44feb3e.png";